// Nombre de una categoría (cuenta contable) con su código delante cuando lo
// tiene (#74), ej. "5.01.03 Nómina". El orden ya viene del servidor.
export function etiquetaCategoria(c) {
  if (!c) return '';
  return c.codigo ? `${c.codigo} ${c.nombre}` : c.nombre;
}
